<div class="flex items-center justify-between">
  <h1
    class="pb-5 font-bold text-neutral-800 font-brand text-28px"
    translate="zerosix.register.account-not-found.title"
  ></h1>
  <app-rounded-icon-button
    icon="icon-cross"
    (onClick)="onClose.emit($event)"
  ></app-rounded-icon-button>
</div>

<p translate="zerosix.register.account-not-found.text"></p>

<div class="flex flex-wrap justify-center mt-10 xm:flex-nowrap">
  <div class="w-full xm:pr-1 xm:w-1/2">
    <app-button-atom
      size="L"
      [label]="'zerosix.register.account-not-found.back-button' | translate"
      type="light"
      (click)="onGoToPhoneStep()"
      [full]="true"
    ></app-button-atom>
  </div>
</div>
